// The audience-filter selection shared by the donor list, the filter modal
// and the message editor. One canonical 10-key shape everywhere: every
// producer publishes through normalizeFilters, so a persisted stub from an
// older build (7 keys), a missing key, or a different key order can never
// read as "the filters changed" (which used to wipe the selection on every
// mount and reload).
export const FILTER_KEYS = [
  'donorTypes',
  'bloodTiters',
  'donorStatuses',
  'appUserStatuses',
  'smsStatuses',
  'quarantineDue',
  'nextAppointment',
  'eligibleFor',
  'hasAppointment',
  'selfService',
];

export const EMPTY_FILTERS = Object.freeze({
  donorTypes: [],
  bloodTiters: [],
  donorStatuses: [],
  appUserStatuses: [],
  smsStatuses: [],
  quarantineDue: [],
  nextAppointment: [],
  eligibleFor: [],
  hasAppointment: [],
  selfService: false,
});

const asArray = (value) => (Array.isArray(value) ? value.slice() : []);

export const normalizeFilters = (input) => {
  const source = input && typeof input === 'object' ? input : {};
  return FILTER_KEYS.reduce((acc, key) => {
    acc[key] = key === 'selfService' ? Boolean(source[key]) : asArray(source[key]);
    return acc;
  }, {});
};

// Key-order-insensitive structural stringify (blood-type entries are small
// objects whose key order depends on which code path built them).
const stableStringify = (value) => {
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(',')}]`;
  if (value && typeof value === 'object') {
    return `{${Object.keys(value).sort().map((k) => `${JSON.stringify(k)}:${stableStringify(value[k])}`).join(',')}}`;
  }
  return JSON.stringify(value === undefined ? null : value);
};

export const sameFilters = (a, b) => stableStringify(normalizeFilters(a)) === stableStringify(normalizeFilters(b));

// Number of active filter terms — the badge on the "+ Filter" button.
export const countFilters = (filters) => {
  const f = normalizeFilters(filters);
  return FILTER_KEYS.reduce((n, key) => n + (key === 'selfService' ? (f[key] ? 1 : 0) : f[key].length), 0);
};
